import { createSlice } from "@reduxjs/toolkit";
import { find, lowerCase } from "lodash";

export const chapterInitialState = {
  chapter: null,
};
export const sliceName = "chapter";
export const chapterSlice = createSlice({
  name: sliceName,
  initialState: chapterInitialState,
  reducers: {
    setChapter: (state, action) => {
      state.chapter = action.payload;
    },
  },
});

export const { setChapter } = chapterSlice.actions;
export const selectChapter = (state) => state[sliceName].chapter;
export const selectChapterId = (state) => state[sliceName].chapter?.id ?? "nan";
export const selectOfficer = (email) => (state) => {
  const officersEmail = state[sliceName]?.chapter?.officersEmail ?? [];
  return !!find(officersEmail, (obj) => lowerCase(obj) === lowerCase(email));
};
